import { post } from 'api/client';
import { FeaturesSlugs } from 'types/Account';
import { jsonToFormData } from 'utils/formData';

export function requestFeatureTrial(feature: FeaturesSlugs) {
  return post('/features/ajaxRequestTrial', jsonToFormData({ feature }));
}
